<template>
  <span ref="box" class="mbo-fit">
    <span ref="text" class="mbo-fit__text" :style="{fontSize: size + 'px'}">{{ text }}</span>
  </span>
</template>

<script>
// Длинные названия и ники уменьшаются до размера слота, а не обрезаются
export default {
  name: 'MbFitText',
  props: {
    text: {type: [String, Number], default: ''},
    max: {type: Number, required: true},
    min: {type: Number, default: 14},
  },
  data() {
    return {size: this.max}
  },
  watch: {
    text: 'refit',
    max: 'refit',
  },
  mounted() {
    this.refit()
    // шрифт эфира грузится с Google Fonts — пересчитываем, когда он подъехал
    if (document.fonts?.ready) document.fonts.ready.then(() => this.refit())
  },
  methods: {
    async refit() {
      this.size = this.max
      await this.$nextTick()
      const box = this.$refs.box
      const text = this.$refs.text
      if (!box || !text || !box.clientWidth) return
      let size = this.max
      while (size > this.min && text.scrollWidth > box.clientWidth) {
        size -= 1
        text.style.fontSize = size + 'px'
      }
      this.size = size
    },
  },
}
</script>
